import { useIsTrainingModeEnabled } from '../../hooks/useIsTrainingModeEnabled.ts';
import { isWeb } from '../WebOnly/utils.ts';

type Environment = 'web' | 'regularMode';

type EnvironmentCheckParams = {
  isTrainingModeEnabled: boolean;
};

const environmentChecks: Record<Environment, (params: EnvironmentCheckParams) => boolean> = {
  web: () => isWeb(),
  regularMode: ({ isTrainingModeEnabled }) => !isTrainingModeEnabled,
};

type Props = React.PropsWithChildren<{
  environments: Environment[];
}>;

/**
 * Only renders `children` when running Toolkit in all `environments`.
 *
 * Environments:
 * - `web` = not an integration (e.g., SFREP)
 * - `regularMode` = not training mode
 */
export const EnvironmentFilter = ({ environments, children }: Props) => {
  const { isTrainingModeEnabled } = useIsTrainingModeEnabled();

  const shouldRender = environments.every((env) =>
    environmentChecks[env]({ isTrainingModeEnabled }),
  );

  return shouldRender ? children : null;
};
